import { useEffect, useId, useState } from "react";
import { HinduShuffleView } from "./HinduShuffleView.js";
import { hinduStepAt } from "./hinduStep.js";

export function HinduShuffleMotion() {
  const clipId = useId().replace(/:/g, "");
  const [elapsed, setElapsed] = useState(0);
  const reduced = typeof window !== "undefined"
    && typeof window.matchMedia === "function"
    && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  useEffect(() => {
    if (reduced) return undefined;
    const start = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      const next = now - start;
      setElapsed(next);
      if (!hinduStepAt(next).done) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [reduced]);

  if (reduced) return null;
  return <HinduShuffleView elapsed={elapsed} clipId={`hindu-out-${clipId}`} />;
}
